<template>
	<v-container fluid class="ma-0 pa-0">
		<Header />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
      <v-row class="ma-0 pa-0 pt-10">
        <v-col class="ma-0 pa-0 mb-4" cols="12" align="left">
        {{'장비 교체 시나리오'}}
        </v-col>
        <v-col class="ma-0 pa-0 pt-2" cols="6" align="left">
          <v-row class="ma-0 pa-0 pb-7">
            <v-col class="ma-0 pa-0" align-self="center">
              {{'contractCd'}}
            </v-col>
            <v-col class="ma-0 pa-0">
              <v-select v-model="contractCd"
                :items="contractCdList" item-text="contractCd" item-value="contractCd"
                dense hide-details outlined dark>
                
              </v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0 pb-7">
            <v-col class="ma-0 pa-0" align-self="center">
              {{'old Device SerialCd'}}
            </v-col>
            <v-col class="ma-0 pa-0">
              <v-select v-model="oldSerialCd"
                :items="oldSerialCdList" item-text="serialCd" item-value="serialCd"
                dense hide-details outlined dark>
                
              </v-select>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0 pb-10">
            <v-col class="ma-0 pa-0" align-self="center">
              {{'new Device SerialCd'}}
            </v-col>
            <v-col class="ma-0 pa-0">
              <input id="input_grey" v-model="newSerialCd" placeholder="new device serial cd">
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0 mt-7" justify="space-around">
            <v-btn id="blue_btn" @click="deviceReplacement">{{'1. 교체 요청'}}</v-btn>
            <v-btn id="blue_btn" @click="deviceInstall">{{'2. 설치 완료'}}</v-btn>
            <v-btn id="blue_btn" @click="deviceComplete">{{'3. 회수 완료'}}</v-btn>
          </v-row>
        </v-col>
        <v-col class="ma-0 pa-0 pl-10" cols="6">
          <v-row class="ma-0 pa-0">
            <v-col class="ma-0 pa-0">
              <v-row class="ma-0 pa-0 pb-2" id="text_big">
                {{'old device'}}
              </v-row>
              <v-row class="ma-0 pa-0 pb-1">
                {{'serialCd : '}} {{oldDeviceStatus.serialCd}}
              </v-row>
              <v-row class="ma-0 pa-0 pb-1">
                {{'deviceStatusCd : '}} {{oldDeviceStatus.deviceStatusCd}}
              </v-row>
              <v-row class="ma-0 pa-0 pb-1">
                {{'deviceStatusName : '}} {{oldDeviceStatus.deviceStatusName}}
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0 mt-10">
            <v-col class="ma-0 pa-0">
              <v-row class="ma-0 pa-0 pb-2" id="text_big">
                {{'new device'}}
              </v-row>
              <v-row class="ma-0 pa-0 pb-1">
                {{'serialCd : '}} {{newDeviceStatus.serialCd}}
              </v-row>
              <v-row class="ma-0 pa-0 pb-1">
                {{'deviceStatusCd : '}} {{newDeviceStatus.deviceStatusCd}}
              </v-row>
              <v-row class="ma-0 pa-0 pb-1">
                {{'deviceStatusName : '}} {{newDeviceStatus.deviceStatusName}}
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import mixin from '@/mixin';
import Header from './Header.vue';
export default {
  components: {
    Header
  },
	mixins: [mixin.common],
  data: () => ({
    contractCd: '',
    contractCdList: [],
    oldSerialCd: '', //old device serial cd
    oldSerialCdList: [],
    newSerialCd: '', //new device serial cd

    //old device data
    oldDeviceStatus: {},
    //new device data
    newDeviceStatus: {},
  }),
  mounted() {
    this.getContractCdList();
    this.getAllDeviceSignup();
  },
  watch: {
  },
  methods: {
    async getContractCdList() {
      let params = {};
      await this.networkController.getContractCdList(params)
			.then(async (res) => {
				this.contractCdList = res.data;
        console.log(this.contractCdList);
			}).catch(error => { });
    },
    async getAllDeviceSignup() {
      let params = {};
      await this.networkController.getAllDeviceSignup(params)
			.then(async (res) => {
        this.oldSerialCdList = res.data;
        console.log(res.data);
			}).catch(error => { });
    },
    async deviceReplacement() {
      let params = {
        contractCd: this.contractCd,
        newSerialCd: this.newSerialCd,
        oldSerialCd: this.oldSerialCd
      };
      await this.networkController.deviceReplacement(params)
      .then(async (res) => {
        this.$dialog.message.success(this.tmb('requestSuccess'), {
				  	position: 'top', timeout: 3000
				  });
        this.oldDeviceStatus = res.data.oldDeviceStatus;
        this.newDeviceStatus = res.data.newDeviceStatus;
      }).catch(error => {
        const message = error.response.data.msg;
        if(message != null) {
          this.$dialog.message.error(message, {
				  	position: 'top', timeout: 3000
				  });
        } else {
          this.$dialog.message.error(this.tmb('requestFail'), {
				  	position: 'top', timeout: 3000
				  });
        }
      });
    },
    async deviceInstall() {
      let params = {
        contractCd: this.contractCd,
        newSerialCd: this.newSerialCd,
        oldSerialCd: this.oldSerialCd
      };
      await this.networkController.deviceInstall(params)
      .then(async (res) => {
        this.$dialog.message.success(this.tmb('requestSuccess'), {
				  	position: 'top', timeout: 3000
				  });
        this.oldDeviceStatus = res.data.oldDeviceStatus;
        this.newDeviceStatus = res.data.newDeviceStatus;
      }).catch(error => {
        const message = error.response.data.msg;
        if(message != null) {
          this.$dialog.message.error(message, {
				  	position: 'top', timeout: 3000
				  });
        } else {
          this.$dialog.message.error(this.tmb('requestFail'), {
				  	position: 'top', timeout: 3000
				  });
        }
      });
    },
    async deviceComplete() {
      let params = {
        contractCd: this.contractCd,
        newSerialCd: this.newSerialCd,
        oldSerialCd: this.oldSerialCd
      };
      await this.networkController.deviceComplete(params)
      .then(async (res) => {
        this.$dialog.message.success(this.tmb('requestSuccess'), {
				  	position: 'top', timeout: 3000
				  });
        this.oldDeviceStatus = res.data.oldDeviceStatus;
        this.newDeviceStatus = res.data.newDeviceStatus;
      }).catch(error => {
        const message = error.response.data.msg;
        if(message != null) {
          this.$dialog.message.error(message, {
				  	position: 'top', timeout: 3000
				  });
        } else {
          this.$dialog.message.error(this.tmb('requestFail'), {
				  	position: 'top', timeout: 3000
				  });
        }
        
      });
    },
  }

}
</script>

<style lang="scss" scoped>
#input_grey {
	width: 100%;
	height: 2.5rem;
	padding-left: 10px;
}
.v-list{
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
  // Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
#text_big {
  font-size: 1.5rem;
}
</style>